import { ReceiveMessageBody, WebSocketMessageTypes } from '@/websocket/types'
import { WebSocketMessageMode } from '@/websocket/constants'
import WebSocketReceiver from '@/websocket/receivers/receiver'

export const enum WebSocketMessageMessageTypes {
  MESSAGE = 'message'
}

export default class MessageWebSocketReceiver extends WebSocketReceiver<
  WebSocketMessageMode.MESSAGE
> {
  handleMessage(
    messageBody: ReceiveMessageBody<
      WebSocketMessageMode.MESSAGE,
      WebSocketMessageTypes<WebSocketMessageMode.MESSAGE>
    >
  ) {
    if (!messageBody) {
      return
    }

    switch (messageBody.type) {
      case WebSocketMessageMessageTypes.MESSAGE:
        this.events.emit(WebSocketMessageMessageTypes.MESSAGE, messageBody)
        break
      default:
        break
    }
  }
}
